"use client";

import clsx from "clsx";
import { CSSProperties, useMemo } from "react";
import { createSpacingClasses, SpacingProps } from "@/theme/spacing";
import "./Container.scss";

export type ContainerProps = {
  as?: React.ElementType;
  children: React.ReactNode;
  className?: string;
  display?: CSSProperties["display"];
  justifyContent?: CSSProperties["justifyContent"];
  alignItems?: CSSProperties["alignItems"];
  flexWrap?: CSSProperties["flexWrap"];
  containerClass?: string;
} & SpacingProps;

export const Container = ({
  as,
  children,
  className,
  display,
  justifyContent,
  alignItems,
  flexWrap,
  containerClass = "ui-container",
  ...rest
}: ContainerProps) => {
  const Component = as || "div";
  const classNames = useMemo(() => {
    const spacingClasses = createSpacingClasses(rest);

    return [...spacingClasses].join(" ");
  }, [rest]);

  return (
    <Component
      className={clsx(containerClass, className, classNames)}
      style={{
        display,
        justifyContent,
        alignItems,
        flexWrap,
      }}
    >
      {children}
    </Component>
  );
};
